var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.3633L10.5 9.36328V15.3633L15 12.3633Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.3634C2.25 15.1674 2.53781 16.8118 2.75719 17.6574C2.8152 17.8874 2.92694 18.1004 3.08322 18.2789C3.23951 18.4573 3.43589 18.5962 3.65625 18.684C6.79875 19.8962 12 19.8634 12 19.8634C12 19.8634 17.2012 19.8962 20.3438 18.684C20.5648 18.5966 20.7619 18.458 20.9189 18.2795C21.0759 18.1011 21.1882 17.8878 21.2466 17.6574C21.4659 16.8137 21.7537 15.1674 21.7537 12.3634C21.7537 9.55931 21.4659 7.91493 21.2466 7.06931C21.1888 6.83805 21.0768 6.62388 20.9198 6.44454C20.7628 6.2652 20.5653 6.12585 20.3438 6.03806C17.2012 4.83056 12 4.86337 12 4.86337C12 4.86337 6.79875 4.83056 3.65625 6.04274C3.43466 6.13054 3.23718 6.26988 3.08017 6.44922C2.92317 6.62856 2.81116 6.84274 2.75344 7.07399C2.53781 7.91399 2.25 9.55931 2.25 12.3634Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2ebdee91c1b355aa8bb953014603568e.svg";
export { ForwardRef as ReactComponent };